import React from 'react';
import { createRoot } from 'react-dom/client';
import { mountTimer } from '../features/products/OfferTimer';
import { mobileNavToggle } from '../features/NavBar';
// FEATURES
import { addFeatureToPlan } from '../pages/PlansNew';
import { initPhoneNumbers } from '../pages/PhoneNumbersForm';

// React components mounted onto a DOM node by id. To add one:
//   { id: 'my-page', component: MyPage }
// and render <div id="my-page" data-some-prop="..."></div> in a view.
// Lazy-load heavy pages with component: React.lazy(() => import('../pages/MyPage')).
const mounts = [];

const mountPages = () => {
  mounts.forEach((mount) => {
    const rootEl = document.getElementById(mount.id);
    if (rootEl) {
      // 1. READ DATA ATTRIBUTES
      // dataset.submitUrl converts data-submit-url to submitUrl
      const props = { ...rootEl.dataset };
      // 2. PARSE JSON PROP
      // HTML attributes are always strings, so we must JSON.parse the object
      // ex. data-initial-data="<%= initial_state.to_json %>"
      if (props.initialData) {
        try {
          props.initialData = JSON.parse(props.initialData);
        } catch (e) {
          console.error('Failed to parse initial data', e);
        }
      }
      const root = createRoot(rootEl);
      root.render(<mount.component {...props} />);
    }
  });
};
document.addEventListener('DOMContentLoaded', function () {
  mountPages();
  mountTimer();
  addFeatureToPlan();
  initPhoneNumbers();
  mobileNavToggle();
});
